module.exports = "/_next/static/images/truck4-e1889596794077fe6e067e0bd7c90294.png.webp";